import axios from "../utils/axios";

// ==========================================
// Tax Zones
// ==========================================

export const getTaxZones = async (params) => {
    const response = await axios.get("/admin/tax-zones", { params });
    return response.data;
};

export const getTaxZoneById = async (id) => {
    const response = await axios.get(`/admin/tax-zones/${id}`);
    return response.data;
};

export const createTaxZone = async (data) => {
    const response = await axios.post("/admin/tax-zones", data);
    return response.data;
};

export const updateTaxZone = async (id, data) => {
    const response = await axios.put(`/admin/tax-zones/${id}`, data);
    return response.data;
};

export const deleteTaxZone = async (id) => {
    const response = await axios.delete(`/admin/tax-zones/${id}`);
    return response.data;
};

// ==========================================
// Tax Rates
// ==========================================

export const getTaxRates = async (params) => {
    const response = await axios.get("/admin/tax-rates", { params });
    return response.data;
};

export const getTaxRateById = async (id) => {
    const response = await axios.get(`/admin/tax-rates/${id}`);
    return response.data;
};

export const createTaxRate = async (data) => {
    const response = await axios.post("/admin/tax-rates", data);
    return response.data;
};

export const updateTaxRate = async (id, data) => {
    const response = await axios.put(`/admin/tax-rates/${id}`, data);
    return response.data;
};

export const deleteTaxRate = async (id) => {
    const response = await axios.delete(`/admin/tax-rates/${id}`);
    return response.data;
};
